import React from "react";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import AppSlideFadeIn from "../../Generic/AppSlideFadeIn";
import { RafflePreviousWinner, RafflePrize } from "../Raffle.types";
import RaffleHeading from "./RaffleHeading";
import RafflePreviousWinnersCard from "./RafflePreviousWinnersCard";
import RafflePrizeImage from "./RafflePrizeImage";
import { RaffleSection } from "./RaffleSection";
import RaffleSectionTitle from "./RaffleSectionTitle";
import { RaffleTextBanner } from "./RaffleTextBanner";
import { RaffleTrophy } from "./RaffleTrophy";

type Props = {
  previousWinners: RafflePreviousWinner[];
  prize: RafflePrize;
};

export default function RaffleScreenEnded(props: Props) {
  return (
    <>
      <AppSlideFadeIn>
        <RaffleSection mt={72}>
          <RaffleHeading subTitle={translate(STRINGS.RAFFLE_ENDED)} title={props.prize.name} />
        </RaffleSection>
      </AppSlideFadeIn>

      <AppSlideFadeIn delay={100}>
        <RafflePrizeImage size={200} prize={props.prize.name} prizeImage={props.prize.image} />
      </AppSlideFadeIn>

      <AppSlideFadeIn delay={200}>
        <RaffleSection mb={54} mx={16}>
          <RaffleTextBanner>{translate(STRINGS.STAY_TUNED_FOR_THE_NEXT_RAFFLE)}</RaffleTextBanner>
        </RaffleSection>
      </AppSlideFadeIn>

      {props.previousWinners.length > 0 && (
        <AppSlideFadeIn delay={300}>
          <RaffleSection mx={24} my={24}>
            <RaffleSectionTitle>
              <RaffleTrophy />
              <span>{translate(STRINGS.PREVIOUS_WINNERS)}</span>
            </RaffleSectionTitle>
            <RafflePreviousWinnersCard previousWinners={props.previousWinners} />
          </RaffleSection>
        </AppSlideFadeIn>
      )}
    </>
  );
}
